/**
 * The display settings behind the toolbar gear (DSGN-63 Phase 1, Figma
 * "Display" frames). The defaults and ranges come from the designer's notes
 * on those frames:
 *
 * - Entity Label: the name under each node icon. Default on.
 * - Edge Label: the relationship text along each line. Default off.
 * - Orphans: nodes with no connection in the currently filtered graph.
 *   Default off (hidden), never deleted.
 * - Line Thickness: 1.0–4.0 px in 0.5 steps, default 2.0 (the design's
 *   Display frame), applied as the slider moves. Node borders, icons and
 *   text are unaffected.
 *
 * Kept beside the popover rather than in it so the component file exports
 * only a component (react-refresh), the same reason `layoutOptions.ts` exists.
 */
export interface DisplaySettings {
  entityLabels: boolean
  edgeLabels: boolean
  orphans: boolean
  lineWidth: number
}

export const DEFAULT_DISPLAY_SETTINGS: DisplaySettings = {
  entityLabels: true,
  edgeLabels: false,
  orphans: false,
  lineWidth: 2,
}

export const LINE_WIDTH_MIN = 1
export const LINE_WIDTH_MAX = 4
export const LINE_WIDTH_STEP = 0.5
